import { Injectable } from '@angular/core';
import { debug } from 'util';

@Injectable()

export class AlgoritmoVentaTrosten {

	tiposDia:any = {
		UNICO: 1,
		INICIAL: 2,
		FINAL: 3,
		INTERMEDIO: 4,
		NOHABIL: 5,
		DIASCOTIZADOS:6
	};
	// Estas varuables son sólo para fines de demostración de la UI
	diasNaturales:any = 0;
	costoUnidad:any = 0;
	costoDiaUnico:any = 0;
	costoDiaInicial:any = 0;
	costoDiaFinal:any = 0;
	costoDiasIntermedios:any = 0;
	COSTO_FIJO_POR_UNIDAD:any = 1000;
	COSTO_FIJO_HOSPEDAJE:any = 350;
	COSTO_FIJO_COMIDA:any = 60;
	COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL:any = 150;
	COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL:any = 250;
	COSTO_FIJO_COMIDA_EXTENDIDO:any =150;
	COSTO_POR_KM_DE_MANTENIMIENTO:any = 1; // $1.00 / km

	costoCombustible:any = {
		gasolina : 18,
		diesel : 18
	};

	unidades:any = {
		TIPO1 : {
			rendimiento: 7,
			combustible: this.costoCombustible.gasolina
		},
		TIPO2: {
			rendimiento: 7,
			combustible: this.costoCombustible.diesel
		},
		LUJO: {
			rendimiento: 7,
			combustible: this.costoCombustible.gasolina
		},
		AUTO: {
			rendimiento: 7,
			combustible: this.costoCombustible.diesel
		}
	};

	/**
	 * Agrega una cantidad determinada de kilometros de acuerdo a cuanto se hayan enviado
	 * Esto es para poder contar con un colchon de kilometraje a recorrer durante el viaje
	 * @param kilometros
	 */
	public calcularKilometrosDeDistancia(kilometros){
		if(kilometros <= 50)
			return kilometros + 30;
		else if(kilometros <= 150)
			return  kilometros + 50;
		else if(kilometros <= 300)
			return  kilometros + 100;
		else if(kilometros <= 500)
			return kilometros + 150;
		else
			return kilometros + 200;
	}

	/**
	 * Calcula la duracion de la ruta de acuerdo a lo obtenido por Google
	 * @param ruta
	 */
	calcularDuracionRuta(ruta){
		// Inicializa la duracion
		let duracion = 0;
		// Suma la duracion de la ruta
		for (var i = 0; i < ruta.legs.length; i++) {
			// Suma la duracion del viaje utilizando milisegundos
			duracion += ruta.legs[i].duration.value * 1000;
		}
		// Al tiempo aproximado obtenido se le suma un 15%
		duracion *= 1.15;

		return duracion;
	}

	/**
	 * Devuelve un objeto de itinerario para poder calcular los costos de venta
	 * @param servicio Objeto de servicio completo
	 */
	generarObjetoItinerario(servicio:any){
		let itinerario = {
			// Este campo contiene los valores de inicio y fin del servicio
			ida: {
				salida: servicio.itinerario.inicioDeServicio,
				// Selecciona el fin de servicio dependiendo del tipo de viaje
				llegada: servicio.itinerario.finDeServicio
			},
			// Este campo contiene el tiempo desde que la unidad llega a su destino hasta que va a regresar
			traslado:{
				llegada : servicio.tipoDeViaje == 'Viaje Redondo' ? servicio.itinerario.llegadaADestino : null,
				inicioRegreso: servicio.tipoDeViaje == 'Viaje Redondo' ? servicio.itinerario.regresoAOrigen : null
			}
		}

		return itinerario;
	}

	/**
	 * Divide un timestamp en un objeto que contiene cada propiedad separada
	 * @param timestamp
	 */
	private dividirFecha(timestamp:number){
		// Crea un nuevo objeto de fecha
		let fecha = new Date(timestamp);

		// Construye el nuevo objeto con sus componentes
		let objetoFecha = {
			hora : fecha.getHours(),
			dia : fecha.getDate(),
			mes : fecha.getMonth(),
			ano : fecha.getFullYear(),
			diasemana: fecha.getDay()
		};

		return objetoFecha;
	}

	/**
	 * Calcula los kilometros de la ruta de acuerdo a lo obtenido por Google
	 * @param ruta
	 */
	calcularKilometrosRuta(ruta){
		// Inicializa los kilometros
		let kilometros = 1;
		// Suma los kilometros de la ruta
		for (var i = 0; i < ruta.legs.length; i++) {
			// Suma los kilometros
            console.log("Distance sin Trim", parseInt(ruta.legs[i].distance.text.replace("km", "").replace(",", "")))
            console.log("LEG", parseInt(ruta.legs[i].distance.text.replace("km", "").replace(",", "").trim()))
			kilometros += parseInt(ruta.legs[i].distance.text.replace("km", "").replace(",", "").trim());
		}
		return kilometros;
	}

	//algoritmo de calculo para dias Intermedios Basados en Excel de Juan
	calcularDiasIntermedios(itinerario){
		// Datos de la fecha inicial
		let fechaInicial = new Date(itinerario.ida.salida);


		// Datos de la fecha de fin de servicio
		let fechaFinal = new Date(itinerario.ida.llegada);
		let fechafinTraslado = new Date(itinerario.traslado.llegada);
		let fechaInicioRegreso = new Date(itinerario.traslado.inicioRegreso)
		//datos de la fecha final en el traslado inicial
		if(fechafinTraslado.getDate() > fechaInicial.getDate()){
			fechaInicial.setDate(fechaInicial.getDate() + 1);
		}
		if(fechaInicial.getHours() <=20){
			fechaInicial.setDate(fechaInicial.getDate() + 1);
		}
		if(fechaInicioRegreso.getDate() < fechaFinal.getDate()){
			fechaFinal.setDate(fechaFinal.getDate() - 1);
		}

		let fechaFinalComparar= new Date(fechaFinal.toDateString())
		let fechaInicialComparar = new Date(fechaInicial.toDateString())
		let resultado = Math.floor((fechaFinalComparar.getTime() - fechaInicialComparar.getTime()) /(1000*60*60*24))
		return resultado;
	}

	//algoritmo proporcionado por Pepe para calculo de Honorarios
	calcularViaticosHonorarios(itinerario, kilometros){
		// Datos de la fecha inicial
		let fechaInicial = new Date(itinerario.ida.salida);
		let costo = 0;
		let diasFinancieros = this.calcularDiasFinancieros(itinerario);
		if(diasFinancieros==1){
			let hora = 3600000; // Hora en milisegundos
			let horasEntreFechas = Math.ceil((itinerario.ida.llegada - itinerario.ida.salida) / hora);
			// Datos de la fecha inicial
			let fechaInicial = new Date(itinerario.ida.salida);
			let objetoFechaInicial = {
				hora : fechaInicial.getHours(),
				dia : fechaInicial.getDate(),
				mes : fechaInicial.getMonth(),
				ano : fechaInicial.getFullYear(),
				diasemana:fechaInicial.getDay()
			};

			// Datos de la fecha de fin de servicio
			let fechaFinal = new Date(itinerario.ida.llegada);
			let objetoFechaFinal = {
				hora : fechaFinal.getHours(),
				minutos : fechaFinal.getMinutes(),
				dia : fechaFinal.getDate(),
				mes : fechaFinal.getMonth(),
				ano : fechaFinal.getFullYear(),
				diasemana:fechaFinal.getDay()
			};
				if(objetoFechaInicial.dia == objetoFechaFinal.dia){
					if(objetoFechaInicial.diasemana ==0){
						//se cambiaron las hora a 8 como en la presentacion de trosten, y el menor a 11.5 para dia habil conforme a lo que esta en la presentacion y lo que se hace actualmente
						if(horasEntreFechas<8){
							costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
						}else{
							costo= this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL;
						}
					}else{
						if(horasEntreFechas<11.5){
							costo= 0;
						}else if(kilometros>=400 && kilometros<800){
							costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
						}else if(kilometros>=800){
							costo= this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL;
						}else{
							costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
						}
					}
				}else if(objetoFechaFinal.hora<1){
					if(objetoFechaInicial.diasemana ==0){
						if(horasEntreFechas<6){
							costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
						}else{
							costo= this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL;
						}
					}else{
						if(kilometros<400 && horasEntreFechas<15){
							costo=0;
						}else if(kilometros>=400 && kilometros<800){
							costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
						}else if(kilometros>=800){
							costo= this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL;
						}else{
							costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
						}
					}
				}else{
					if(objetoFechaInicial.diasemana==0){
						costo= this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL;
					}else{
						costo = this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
					}
				}
		}else{
			let diasNoHabiles = this.cantidadDiasNoHabiles(fechaInicial,diasFinancieros)
			costo += (diasFinancieros - diasNoHabiles) * this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL;
			costo += diasNoHabiles * this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL;
		}
		return costo;
	}

	//variables para saber cuales son las horas exactas que un operador maneja
	horasRealesDiaInicial= 0;
	horasRealesDiaFinal= 0;

	//algoritmo cambiado durante la revision con el contador
	calcularCostoComidasDiaInicialFinal(horasServicio){
			let costo =0;
			if(horasServicio<5){
				costo= this.COSTO_FIJO_COMIDA*1;
			}else if(horasServicio<9){
				costo= this.COSTO_FIJO_COMIDA*2;
			}else if(horasServicio<20){
				costo= this.COSTO_FIJO_COMIDA*3;
			}else{
			costo = this.COSTO_FIJO_COMIDA_EXTENDIDO + (this.COSTO_FIJO_COMIDA * 3 ) ;
			}
			return costo;
		}
	calcularDiasFinancieros(itinerario){
		// Obtenemos la cantidad de horas entre las fechas
		let hora = 3600000; // Hora en milisegundos
		let horasEntreFechas = Math.ceil((itinerario.ida.llegada - itinerario.ida.salida) / hora);
		let diasFinancieros = 0;

		// Datos de la fecha inicial
		let fechaInicial = new Date(itinerario.ida.salida);
		// Datos de la fecha de fin de servicio
		let fechaFinal = new Date(itinerario.ida.llegada);

		if(fechaInicial.getTimezoneOffset() < fechaInicial.getTimezoneOffset()){
			horasEntreFechas++;
		}else if(fechaInicial.getTimezoneOffset() > fechaInicial.getTimezoneOffset()){
			horasEntreFechas--;
		}
		diasFinancieros = Math.floor((itinerario.ida.llegada - itinerario.ida.salida) /(1000*60*60*24));
		if(fechaFinal.getHours() > 6){
			diasFinancieros++;
		}
		return diasFinancieros;
	}

	/**
	 * Calcula los días naturales que hay entre dos fechas
	 * @param itinerario
	 * @param nochesDeHospedaje
	 */
	calcularDiasNaturales(itinerario, nochesDeHospedaje){
		// Se inicializa el arreglo de días naturales dentre las fechas
		let diasNaturales = [];

		// Obtenemos la cantidad de horas entre las fechas de inicio y fin de servicio
		let hora = 3600000; // Hora en milisegundos
		let horasEntreFechas = Math.ceil((itinerario.ida.llegada - itinerario.ida.salida) / hora);

		// Divide los timestamps en sus componentes
		let objetoFechaInicial = this.dividirFecha(itinerario.ida.salida);
		let objetoFechaFinal = this.dividirFecha(itinerario.ida.llegada);

		// Checa si el viaje inicia y termina en el mismo día
		if(objetoFechaInicial.dia == objetoFechaFinal.dia && objetoFechaInicial.mes == objetoFechaFinal.mes && objetoFechaInicial.ano == objetoFechaFinal.ano){
			// Genera un arreglo con el objeto de dia unico
			diasNaturales.push({
				tipoDia : this.tiposDia.UNICO,
				horasDeServicio : horasEntreFechas,
				horaDeInicio: objetoFechaInicial.hora,
				horaDeFin: objetoFechaFinal.hora,
				esHabil: objetoFechaFinal.diasemana == 0 ? false : true
			});
		} else {

			// Cálculo de horas de servicio por día
			let horasDeServicioDiaInicial = 24 - objetoFechaInicial.hora;
			let horasDeServicioDiaFinal = objetoFechaFinal.hora;
			let horasDeServicioIntermedias = horasEntreFechas - (horasDeServicioDiaInicial + horasDeServicioDiaFinal);

			// Se calculan los dias naturales dividiendo las horas intermedias para saber cuantos dias intermedios existen y agregando 2 para agregar el dia inicial y dia final
			let diasHorasNaturales = Math.round((horasDeServicioIntermedias / 24) + 2);

			if(nochesDeHospedaje < diasHorasNaturales - 2){
				let calculoInicioServicioSiguientesCeroHoras = 24 - objetoFechaInicial.hora
					horasDeServicioDiaInicial = 24;
					horasDeServicioIntermedias -= 24;
					horasDeServicioDiaInicial += calculoInicioServicioSiguientesCeroHoras;
					horasDeServicioDiaFinal = 24;
					horasDeServicioIntermedias -= 24;
					horasDeServicioDiaFinal += objetoFechaFinal.hora;
			}else if(nochesDeHospedaje<diasHorasNaturales - 1){
				let calculoInicioServicioSiguientesCeroHoras = 24 - objetoFechaInicial.hora
				if(calculoInicioServicioSiguientesCeroHoras < objetoFechaFinal.hora ){
					horasDeServicioDiaInicial = 24;
					horasDeServicioIntermedias -= 24;
					horasDeServicioDiaInicial += calculoInicioServicioSiguientesCeroHoras;
				}else{
					horasDeServicioDiaFinal = 24;
					horasDeServicioIntermedias -= 24;
					horasDeServicioDiaFinal += objetoFechaFinal.hora;
				}
			}

			// Se dan 15 minutos de tolerancia para agregar otra hora
			if (objetoFechaFinal['minutos'] > 15) {
				horasDeServicioDiaFinal += 1;
				horasDeServicioIntermedias -= 1;
			} else if (objetoFechaFinal['minutos'] > 0 && objetoFechaFinal['minutos'] <= 15) {
				horasDeServicioIntermedias -= 1;
			}

			// Calcula cuantos dias no habiles existen en todo el servicio
			let diasnoHabiles = this.cantidadDiasNoHabiles(new Date(itinerario.ida.salida), diasHorasNaturales);

			// Configuración del arreglo de días naturales
			diasNaturales = [
				{
					tipoDia : this.tiposDia.INICIAL,
					horasDeServicio : horasDeServicioDiaInicial,
					horaDeInicio: objetoFechaInicial.hora,
					dia: objetoFechaInicial.dia
				},
				{
					tipoDia : this.tiposDia.FINAL,
					horasDeServicio : horasDeServicioDiaFinal,
					horaDeFin: objetoFechaFinal.hora,
					dia: objetoFechaFinal.dia
				},
				{
					tipoDia : this.tiposDia.INTERMEDIO,
					horasDeServicio : horasDeServicioIntermedias,
					horasEntreFechas:horasEntreFechas
				},
				{
					tipoDia : this.tiposDia.NOHABIL,
					dias : diasnoHabiles
				},
				{
					tipoDia : this.tiposDia.DIASCOTIZADOS,
					dias : diasHorasNaturales - diasnoHabiles
				}
			];

		}

		return diasNaturales;
	};

	// calcular cantidad de dias nohabiles
	cantidadDiasNoHabiles(fechainicial, diasNaturales){
		let diasNoHabiles = 0;
		var result = fechainicial;
		result.setDate(result.getDate() - 1);
		for (var i = 0; i < diasNaturales; ++i) {
			if(this.esDiaHabil(result.setDate(result.getDate() + 1))){
				diasNoHabiles ++;
			}
		}
		return diasNoHabiles
	}

		/// inician los algoritmos para calcular costos de viaje redondo
    costoFijoMasQuinientos(horasServicio){
			let valorMultiplicar = 0;

			if(horasServicio<8){
				valorMultiplicar = 1.0;
			}else if(horasServicio <13){
				valorMultiplicar = 1.1;
			}else if(horasServicio >12 && horasServicio <17){
				valorMultiplicar = 1.1 + ((horasServicio-12)/10);
			}else if(horasServicio>16){
				valorMultiplicar = 1.5 + ((horasServicio -16) * .15);
			}
			return valorMultiplicar;
		}
    costoFijoMenosQuinientos(horasServicio){

			let valorMultiplicar =0;
			if(horasServicio <13){
				valorMultiplicar = 1.0;
			}else if(horasServicio>12 && horasServicio<18){
				valorMultiplicar = 1 + ((horasServicio-12)/10);
			}else if (horasServicio >17){
				valorMultiplicar = 1.5 + ((horasServicio -17) * .15);
			}
			return valorMultiplicar;
		}
    costoFijoMenosTrecientosMayorDocientos(horasServicio){
			let valorMultiplicar =0;
			if(horasServicio<8){
				valorMultiplicar = 0.9;
			}else if(horasServicio <13){
				valorMultiplicar =1;
			}else if(horasServicio>12 && horasServicio<18){
				valorMultiplicar = 1  + ((horasServicio-12)/10);
			}else if(horasServicio>17){
				valorMultiplicar = 1.5 + ((horasServicio -17) * .15);
			}
			return valorMultiplicar;
		}
    costoFijoMenosDocientos(horasServicio){
			let valorMultiplicar =0;
			if(horasServicio<4){
				valorMultiplicar = 0.7;
			}else if(horasServicio <8){
				valorMultiplicar =0.8;
			}else if(horasServicio<13){
				valorMultiplicar = 1;
			}else if(horasServicio==13){
				valorMultiplicar = 1.075;
			}else if(horasServicio>13 && horasServicio<17){
				valorMultiplicar = 1.15 + ((horasServicio -14) * .10);
			}else if(horasServicio>16 && horasServicio< 25){
				valorMultiplicar = 1.35 + ((horasServicio - 16) *.125);
			}else if(horasServicio>24){
				valorMultiplicar = 2.35 + ((horasServicio -24)* .15);
			}
			return valorMultiplicar;
		}
    costoFijoMenosCien(horasServicio){
			let valorMultiplicar =0;
			if(horasServicio<2){
				valorMultiplicar = 0.5;
			}else if(horasServicio<4){
				valorMultiplicar = 0.6;
			}else if(horasServicio <8){
				valorMultiplicar =0.8;
			}else if(horasServicio<13){
				valorMultiplicar = 1;
			}else if(horasServicio==13){
				valorMultiplicar = 1.075;
			}else if(horasServicio>13 && horasServicio<17){
				valorMultiplicar = 1.15 + ((horasServicio -14) * .10);
			}else if(horasServicio>16 && horasServicio< 25){
				valorMultiplicar = 1.35 + ((horasServicio - 16) *.125);
			}else if(horasServicio>24){
				valorMultiplicar = 2.35 + ((horasServicio -24)* .15);
			}
			return valorMultiplicar;
		}
    costoFijoMenosCuarenta(horasServicio){
			let valorMultiplicar =0;
			if(horasServicio<2){
				valorMultiplicar = 0.4;
			}else if(horasServicio<4){
				valorMultiplicar = 0.5;
			}else if(horasServicio <8){
				valorMultiplicar =0.8;
			}else if(horasServicio<13){
				valorMultiplicar = 1;
			}else if(horasServicio==13){
				valorMultiplicar = 1.075;
			}else if(horasServicio>13 && horasServicio<17){
				valorMultiplicar = 1.15 + ((horasServicio -14) * .10);
			}else if(horasServicio>16 && horasServicio< 25){
				valorMultiplicar = 1.35 + ((horasServicio - 16) * .125);
			}else if(horasServicio>24){
				valorMultiplicar = 2.35 + ((horasServicio -24)* .15);
			}
			return valorMultiplicar;
		}
    costoFijoMenosVeinticinco(horasServicio){
			let valorMultiplicar =0;
			if(horasServicio<1){
				valorMultiplicar = 0.3;
			}else if(horasServicio<2){
				valorMultiplicar = 0.4;
			}else if(horasServicio<4){
				valorMultiplicar = 0.5;
			}else if(horasServicio <8){
				valorMultiplicar =0.8;
			}else if(horasServicio<13){
				valorMultiplicar = 1;
			}else if(horasServicio==13){
				valorMultiplicar = 1.075;
			}else if(horasServicio>13 && horasServicio<17){
				valorMultiplicar = 1.15 + ((horasServicio -14) * .10);
			}else if(horasServicio>16 && horasServicio< 25){
				valorMultiplicar = 1.35 + ((horasServicio - 16) * .125);
			}else if(horasServicio>24){
				valorMultiplicar = 2.35 + ((horasServicio -24)* .15);
			}
			return valorMultiplicar;
		}
	//Terminan algoritmos para calcular costo viaje redondo
	/// inician los algoritmos para calcular costos de traslado
    costoFijoMasQuinientosTraslado(horasServicio){
			let valorMultiplicar = 0;

			if(horasServicio<8){
				valorMultiplicar = 1.6;
			}else if(horasServicio <13	){
				valorMultiplicar = 1.8;
			}else {
				valorMultiplicar = 1.8;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}
    costoFijoMenosQuinientosTraslado(horasServicio){
			let valorMultiplicar = 0;

			if(horasServicio<8){
				valorMultiplicar = 1.5;
			}else if(horasServicio <13	){
				valorMultiplicar = 1.6;
			}else {
				valorMultiplicar = 1.6;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}
    costoFijoMenosTrecientosMasDocientosTraslado(horasServicio){
			let valorMultiplicar = 0;

			if(horasServicio<4){
				valorMultiplicar = 0.7;
			}else if(horasServicio <8	){
				valorMultiplicar = 0.9;
			}else {
				valorMultiplicar = 0.9;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}
    costoFijoMenosDocientosTraslado(horasServicio){
			let valorMultiplicar = 0;
			/*if(horasServicio<=2){
				throw "Aumenta las horas de servicio";
			}else*/ if(horasServicio<4){
				valorMultiplicar = 0.6;
			}else {
				valorMultiplicar = 0.6;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}
    costoFijoMenosCienTraslado(horasServicio){
			let valorMultiplicar = 0;
			/*if(horasServicio<=1){
				throw "Aumenta las horas de servicio";
			}else*/ if(horasServicio<4){
				valorMultiplicar = 0.5;
			}else {
				valorMultiplicar = 0.5;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}
    costoFijoMenosCuarentaTraslado(horasServicio){
			let valorMultiplicar = 0;
			if(horasServicio<=2){
				valorMultiplicar = 0.4;
			}else {
				valorMultiplicar = 0.4;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}
    costoFijoMenosveinticincoTraslado(horasServicio){
			let valorMultiplicar = 0;
			if(horasServicio<1){
				valorMultiplicar = 0.3;
			}else if(horasServicio<=2){
				valorMultiplicar = 0.4;
			}else {
				valorMultiplicar = 0.4;
				//let e = {message:"Reduce las horas de servicio"};
				//throw  e;
			}
			return valorMultiplicar;
		}

	calcularHorasServicioViajeSencillo(itinerario){
		return Math.ceil((itinerario.ida.llegada - itinerario.ida.salida) / 3600000);
	}
	calcularHorasServicioDiaInicial(diaNatural,esDiaExtendido, itinerario, horaFin, diaFecha){
		let horasServicio =0;
		let horaDescansoOperador =0;
		let horasTasladoIntradia = 0;
		let horaInicio = diaNatural.horaDeInicio;
		if(esDiaExtendido){
			horasServicio = Math.ceil((itinerario.ida.llegada - itinerario.ida.salida) / 3600000);
		}else{
			if(horaFin >20){
				horaDescansoOperador = horaFin;
			}else{
				horaDescansoOperador = 20;
			}
			if(diaFecha > diaNatural.dia){
				let horasExtras = 24*(diaFecha - diaNatural.dia)
				horasTasladoIntradia = (24 - horaInicio) + horaFin;
				horasServicio =horaDescansoOperador - horaFin;
			}else{
				horasServicio =horaDescansoOperador - horaInicio;
			}
			horasServicio += horasTasladoIntradia;
			this.horasRealesDiaInicial = horasServicio;
		}
		return horasServicio;
	}
	calcularHorasServicioDiaFinal(diaNatural,horaDeInicio, diaFecha){
		let horasServicio =0;
		let horaDescansoOperador =0;
		let horasTasladoIntradia = 0;
		let horaInicio = horaDeInicio;
				horaDescansoOperador = diaNatural.horaDeFin;
				if(horaInicio>8){
					horaInicio =8;
				}
				if(diaNatural.dia > diaFecha){
					let horasExtras = 24 * (diaNatural.dia- diaFecha);
					horasTasladoIntradia = (horasExtras - horaInicio) + diaNatural.horaDeFin;
					horasServicio =horaDescansoOperador - diaNatural.horaDeFin;
				}else{
					horasServicio =horaDescansoOperador - horaInicio;
				}
				horasServicio += horasTasladoIntradia;
				this.horasRealesDiaFinal = horasServicio;
		return horasServicio;
	}

	// Calcula el costo fijo por unidad
	costoFijoPorUnidad(diasNaturales, itinerario, servicio){
		// Almacena las variables del servicio necsarias para el calculo
		let kilometros = servicio['parametros']['kilometrosDeDistancia'];
		let viajeRedondo = servicio['tipoDeViaje'] == 'Viaje Redondo' ? true : false;
		let datoFechaFinTraslado = new Date(servicio['itinerario']['llegadaADestino']);
		let datoFechaInicioRegreso = new Date(servicio['itinerario']['regresoAOrigen']);

		// Almacena el costo fijo total De la Unidad
		let costoFijoTotal = 0;

		// Variables de tiempo del traslado
		let diaFecha = datoFechaFinTraslado.getDate();
		let horas = datoFechaFinTraslado.getHours();
		let minutos = datoFechaFinTraslado.getMinutes();
		let horaFin = minutos > 15 ? horas+1 : horas;

		// Variables de tiempo del regreso
		let diaFechaRegreso = datoFechaInicioRegreso.getDate();
		let horasRegreso = datoFechaInicioRegreso.getHours();
		let minutosRegreso = datoFechaInicioRegreso.getMinutes();
		let horaFinRegreso = minutosRegreso > 15 ? horasRegreso - 1 : horasRegreso;

		// Verifica si es un dia largo
		let esUnDiaLargo = this.calcularDiasFinancieros(itinerario) == 1 ? true : false;

		// Variable para saber el costo de comidas
		let costoComidas = 0;

		// Checa si es un viaje redondo
		if(viajeRedondo){
			for (let i = 0; i < diasNaturales.length ; i++){
				if(diasNaturales[i].tipoDia != this.tiposDia.NOHABIL && diasNaturales[i].tipoDia != this.tiposDia.DIASCOTIZADOS){
					let costoFijoUnidad = this.COSTO_FIJO_POR_UNIDAD;
					let costoFijoParcial = 0;

					// Checa si el tipo de día es intermedio
					if (diasNaturales[i].tipoDia == this.tiposDia.INTERMEDIO){
						// Multiplica cada día por la el precio fijo de la unidad
						//costoFijoParcial = (diasNaturales[i].horasDeServicio / 24) * costoFijoUnidad;

						//costoFijoParcial = (((diasNaturales[i].horasEntreFechas - this.horasRealesDiaInicial)- this.horasRealesDiaFinal) / 24) * costoFijoUnidad;
						if(!esUnDiaLargo){
							let diasIntermedios = this.calcularDiasIntermedios(itinerario);
						costoFijoParcial =  diasIntermedios * costoFijoUnidad;
						costoComidas+= diasIntermedios * this.COSTO_FIJO_COMIDA * 3;
						}else{
							costoFijoParcial= 0;
						}
						// Esto es sólo con fines de demostración de UI
						this.costoDiasIntermedios = costoFijoParcial;

					} else {
						let horasDeServicio = diasNaturales[i].horasDeServicio;
						let dia = diasNaturales[i].tipoDia;
						if(dia == this.tiposDia.FINAL){
							let horasServicio = this.calcularHorasServicioDiaFinal(diasNaturales[i], horaFinRegreso, diaFechaRegreso);
							costoComidas+= this.calcularCostoComidasDiaInicialFinal(horasServicio);
							if(kilometros<25){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar = this.costoFijoMenosVeinticinco(horasServicio);
								}
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<40){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar = this.costoFijoMenosCuarenta(horasServicio);
								}
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<100){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar = this.costoFijoMenosCien(horasServicio);
								}
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<200){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar = this.costoFijoMenosDocientos(horasServicio);
								}
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros>200 && kilometros<300){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar = this.costoFijoMenosTrecientosMayorDocientos(horasServicio);
								}
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<=500){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar = this.costoFijoMenosQuinientos(horasServicio);
								}
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros>500){
								let valorMultiplicar = 0;
								if(!esUnDiaLargo){
									valorMultiplicar =this.costoFijoMasQuinientos(horasServicio);
								}
								costoFijoUnidad = costoFijoUnidad * valorMultiplicar;
							}
						}else if(dia == this.tiposDia.INICIAL || dia == this.tiposDia.UNICO){
							let horasServicio = this.calcularHorasServicioDiaInicial(diasNaturales[i],esUnDiaLargo,itinerario,horaFin,diaFecha);
							costoComidas+= this.calcularCostoComidasDiaInicialFinal(horasServicio);
							if(kilometros<25){
								let valorMultiplicar = this.costoFijoMenosVeinticinco(horasServicio);
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<40){
								let valorMultiplicar = this.costoFijoMenosCuarenta(horasServicio);
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<100){
								let valorMultiplicar = this.costoFijoMenosCien(horasServicio);
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<200){
								let valorMultiplicar = this.costoFijoMenosDocientos(horasServicio)
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros>200 && kilometros<300){
								let valorMultiplicar = this.costoFijoMenosTrecientosMayorDocientos(horasServicio);
								costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
							}else if(kilometros<=500){
								let valorMultiplicar = this.costoFijoMenosQuinientos(horasServicio);
								costoFijoUnidad= costoFijoUnidad * valorMultiplicar;
							}else if(kilometros>500){
								let valormultiplicar = this.costoFijoMasQuinientos(horasServicio);
								costoFijoUnidad= costoFijoUnidad * valormultiplicar;
							}
						}

						costoFijoParcial = costoFijoUnidad;

						// Este switch es sólo para fines de demostración en UI
						switch(dia){
							case this.tiposDia.INICIAL:
								this.costoDiaInicial = costoFijoParcial;
								break;
							case this.tiposDia.FINAL:
								this.costoDiaFinal = costoFijoParcial;
								break;
							case this.tiposDia.UNICO:
								this.costoDiaUnico = costoFijoParcial;
								break;
						}
					}

					costoFijoTotal += costoFijoParcial;
				}

			}
		} else {
			let horasServicio = this.calcularHorasServicioViajeSencillo(itinerario);
			let costoFijoUnidad = this.COSTO_FIJO_POR_UNIDAD;
			if(kilometros<25){
				let valorMultiplicar = this.costoFijoMenosveinticincoTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}else if(kilometros <40){
				let valorMultiplicar = this.costoFijoMenosCuarentaTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}else if(kilometros<100){
				let valorMultiplicar = this.costoFijoMenosCienTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}else if(kilometros<200){
				let valorMultiplicar = this.costoFijoMenosDocientosTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}else if(kilometros>200 && kilometros<300){
				let valorMultiplicar = this.costoFijoMenosTrecientosMasDocientosTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}else if(kilometros<500){
				let valorMultiplicar = this.costoFijoMenosQuinientosTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}else if(kilometros>500){
				let valorMultiplicar = this.costoFijoMasQuinientosTraslado(horasServicio);
				costoFijoUnidad = valorMultiplicar * costoFijoUnidad;
				this.costoDiaInicial = costoFijoUnidad;
			}
			costoFijoTotal += costoFijoUnidad;
			this.costoDiaFinal = 0;
			this.costoDiasIntermedios = 0;
		}
		let costos = {
			costoTotal : costoFijoTotal,
			costoDiaInicial: this.costoDiaInicial,
			costoDiaFinal: this.costoDiaFinal ,
			costoDiasIntermedios: this.costoDiasIntermedios,
			costoComidas: costoComidas
		}
		return costos;
	};

	calcularCostoGasolina(tipoUnidad, kilometros, kilometrosLocales, esmultidestinos){
		if(esmultidestinos){
			kilometros = kilometros + kilometrosLocales;
		}else{
			kilometros = (kilometros * 2) + kilometrosLocales;
		}
		return (kilometros/this.unidades[tipoUnidad].rendimiento) * this.unidades[tipoUnidad].combustible;
	}

	/**
	 * Calcula el costo de hospedaje del viaje
	 * @param servicio
	 */
	costoHospedaje(servicio){
		return servicio['parametros']['nochesDeHospedaje'] * this.COSTO_FIJO_HOSPEDAJE * servicio['parametros']['cantidadDeOperadores'];
	}

	costoComida(diasNaturales, cantidadOperadores){

		let resultado = 0;
		for (var i in diasNaturales) {

			switch (diasNaturales[i].tipoDia) {
				case this.tiposDia.UNICO:
					if(diasNaturales[i].horaDeInicio < 9 && diasNaturales[i].horaDeFin > 21){
						resultado += (this.COSTO_FIJO_COMIDA * 3) * cantidadOperadores
					}else if(diasNaturales[i].horaDeInicio <9 && diasNaturales[i].horaDeFin > 14){
						resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
					}else if(diasNaturales[i].horaDeInicio <9 && diasNaturales[i].horaDeFin < 12){
						resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
					}else if(diasNaturales[i].horaDeInicio <14 && diasNaturales[i].horaDeFin < 19){
						resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
					}else if(diasNaturales[i].horaDeInicio <14 && diasNaturales[i].horaDeFin < 21){
						resultado += (this.COSTO_FIJO_COMIDA * 2) * cantidadOperadores
					} else if(diasNaturales[i].horaDeInicio <21){
						resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
					}
					break;
				case this.tiposDia.INTERMEDIO:
					let dias = diasNaturales[i].horasDeServicio / 24;
					resultado += dias * (this.COSTO_FIJO_COMIDA * 3) * cantidadOperadores
					break;
				case this.tiposDia.FINAL:
					if(diasNaturales[i].horaDeFin > 21){
						resultado += (this.COSTO_FIJO_COMIDA * 3) * cantidadOperadores
					}else if(diasNaturales[i].horaDeFin > 14){
						resultado += (this.COSTO_FIJO_COMIDA * 2) * cantidadOperadores
					}else if(diasNaturales[i].horaDeFin > 9){
						resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
					}
					break;
				case this.tiposDia.INICIAL:
					if(diasNaturales[i].horasDeServicio > 24){
						if(diasNaturales[i].horaDeInicio < 9){
							resultado += (this.COSTO_FIJO_COMIDA * 3) * cantidadOperadores
						}else if(diasNaturales[i].horaDeInicio <14){
							resultado += (this.COSTO_FIJO_COMIDA * 2) * cantidadOperadores
						}else if(diasNaturales[i].horaDeInicio <21){
							resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
						}
						resultado += (this.COSTO_FIJO_COMIDA * 3) * cantidadOperadores
					}else{
						if(diasNaturales[i].horaDeInicio < 9){
							resultado += (this.COSTO_FIJO_COMIDA * 3) * cantidadOperadores
						}else if(diasNaturales[i].horaDeInicio <14){
							resultado += (this.COSTO_FIJO_COMIDA * 2) * cantidadOperadores
						}else if(diasNaturales[i].horaDeInicio <21){
							resultado += this.COSTO_FIJO_COMIDA * cantidadOperadores
						}
					}
					break;
			}
		}
		return resultado;
	}
	costoHonorarios(diasNaturales){
		let honorarios = 0;
		for (var i in diasNaturales) {
			switch(diasNaturales[i].tipoDia){
				case this.tiposDia.UNICO:
					honorarios+= diasNaturales[i].esHabil?150:250;
				break;
				case this.tiposDia.NOHABIL:
					honorarios+= (diasNaturales[i].dias * this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_INHABIL);
				break;
				case this.tiposDia.DIASCOTIZADOS:
					honorarios+=  (diasNaturales[i].dias * this.COSTO_FIJO_HONORARIOS_OPERADOR_DIA_HABIL);
				break;
			}
		}
		return honorarios;
	}
	calcularCostoImprevistos(costoGas, costoMant, costofijoComidaHospedajeHonorarios, costoCasetas){
		let resultado = Math.round((costoGas + costoMant +costofijoComidaHospedajeHonorarios+(costoCasetas *2)) * .06/50)*50;
		return resultado;
	}

	/**
	 * Revisa si el dia a evaluar es un dia inhabil
	 * @param dia
	 */
	esDiaHabil(dia){
		let diarevisar = new Date(dia);
		if(diarevisar.getDay() == 0){
			return true;
		}else{
			return false;
		}
	}

	costoMantenimento(KilometrosRecorrido, kilometrosEstadia, esMultidestinos){
		let resultado = 0 ;
		if(esMultidestinos){
			resultado = (kilometrosEstadia + KilometrosRecorrido) * this.COSTO_POR_KM_DE_MANTENIMIENTO;
		}else{
			resultado = (kilometrosEstadia + (KilometrosRecorrido * 2)) * this.COSTO_POR_KM_DE_MANTENIMIENTO;
		}
		return resultado;
	}
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/algoritmo-venta-trosten.service.ts